import React, { PureComponent } from 'react';
import uuidv4 from 'uuid/v4';
import { withTranslation } from 'react-i18next';

import CustomFieldDropdownOption from './custom-field-dropdown-option';

import IconPlus from '../icons/icon-plus';

const createOption = autoFocus => ({
    id: uuidv4(),
    name: '',
    color: undefined,
    autoFocus
});

class CustomFieldDropdownOptions extends PureComponent {
    static defaultProps = {
        options: [createOption()]
    }

    state = {
        options: this.props.options
    }

    handleOptionChange = (id, props) => {
        const options = [...this.state.options].map(option => {
            if (option.id === id) {
                return Object.assign({}, option, props);
            }

            return option;
        });

        this.setState({ options });

        this.props.onChange && this.props.onChange(options);
    }

    handleAddNewClick = () => {
        this.setState({
            options: [...this.state.options, createOption(true)]
        });
    }

    handleReturn = () => {
        this.setState({
            options: [...this.state.options, createOption(true)]
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className="form-row">
                <div className="field-label">
                    { t('types.options.title') }
                </div>

                <div className="custom-field-dropdown-options">
                    <div className="custom-field-dropdown-options-list">
                        {
                            this.state.options.map(option => <CustomFieldDropdownOption key={option.id} id={option.id} value={option.value} color={option.color} autoFocus={option.autoFocus} onChange={this.handleOptionChange} onReturn={this.handleReturn} />)
                        }
                    </div>

                    <div className="add-new">
                        <button className="btn btn-link btn-colored" onClick={this.handleAddNewClick}>
                            <IconPlus size="10px" />

                            { t('types.options.addNew') }
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('fields')(CustomFieldDropdownOptions);
